import { Container } from "./container.js";
import { Inject, Injectable, Optional, Singleton } from "./decorators.js";
import { TestingModuleImpl, createMock, createTestingModule } from "./testing.js";
export * from "./types.js";
const defaultContainer = new Container();
function register(provider) {
    defaultContainer.register(provider);
}
function registerSingleton(token, useClass) {
    defaultContainer.registerSingleton(token, useClass);
}
function registerTransient(token, useClass) {
    defaultContainer.registerTransient(token, useClass);
}
function registerValue(token, value) {
    defaultContainer.registerValue(token, value);
}
function registerFactory(token, factory, deps = [], singleton = false) {
    defaultContainer.registerFactory(token, factory, deps, singleton);
}
function resolve(token) {
    return defaultContainer.resolve(token);
}
function get(token) {
    return defaultContainer.get(token);
}
function has(token) {
    return defaultContainer.has(token);
}
function clear() {
    defaultContainer.clear();
}
function registerBatch(providers) {
    defaultContainer.registerBatch(providers);
}
function injectProperties(instance) {
    return defaultContainer.injectProperties(instance);
}
function injectPropertiesSync(instance) {
    defaultContainer.injectPropertiesSync(instance);
}
function createWithPropertyInjection(constructor) {
    return defaultContainer.createWithPropertyInjection(constructor);
}
function createWithPropertyInjectionSync(constructor) {
    return defaultContainer.createWithPropertyInjectionSync(constructor);
}
function getStats() {
    return defaultContainer.getStats();
}
function getPerformanceMetrics() {
    return defaultContainer.getPerformanceMetrics();
}
function resetPerformanceMetrics() {
    defaultContainer.resetPerformanceMetrics();
}
export { Container, Inject, Injectable, Optional, Singleton, TestingModuleImpl, clear, createMock, createTestingModule, createWithPropertyInjection, createWithPropertyInjectionSync, defaultContainer, get, getPerformanceMetrics, getStats, has, injectProperties, injectPropertiesSync, register, registerBatch, registerFactory, registerSingleton, registerTransient, registerValue, resetPerformanceMetrics, resolve };
